import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import reunionService from "./reunionService"

const initialState = {
    reunions: [],
    isLoading: false,
    isError: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 16,
    reunionDetails: {},
    nextPageURI: null,
    prevPageURI: null,
    pageContent: {},
}

export const fetchReunions = createAsyncThunk(
    "reunions/fetchReunions",
    async (currentPage, thunkAPI) => {
        try {
            const { getState } = thunkAPI
            const state = getState().chaptersPage
            return await reunionService.fetchReunions(
                state.perPage,
                currentPage
            )
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "reunions/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await reunionService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchReunionDetails = createAsyncThunk(
    "reunions/fetchReunionDetails",
    async (slug, thunkAPI) => {
        try {
            return await reunionService.fetchReunionDetails(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const reunionSlice = createSlice({
    name: "reunions",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReunions.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchReunions.fulfilled, (state, action) => {
                state.isLoading = false
                state.reunions = [...state.reunions, ...action.payload.data]
                state.currentPage = action.payload.current_page
                state.lastPage = action.payload.last_page
                state.nextPageURI = action.payload.next_page_url
                state.prevPageURI = action.payload.prev_page_url
            })
            .addCase(fetchReunions.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.reunions = []
                state.currentPage = 1
                state.lastPage = 1
                state.nextPageURI = null
                state.prevPageURI = null
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
            .addCase(fetchReunionDetails.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchReunionDetails.fulfilled, (state, action) => {
                state.isLoading = false
                state.reunionDetails = action.payload
            })
            .addCase(fetchReunionDetails.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.errorMessage = action.payload
            })
    },
})

export const { setCurrentPage } = reunionSlice.actions
export default reunionSlice.reducer
